/* Flow "flow — by innovaccer" wordmark + gradient arrow mark.
   Vector paths exported from the Figma source (node 3301:21013) so the mark
   is font-independent and pixel-accurate — the "flow" wordmark uses PolySans
   Bulky, a weight the Seasons @font-face set does not ship, so it must be
   rendered as outlines rather than live text. */
export function FlowLogo({ height = 40, className }: { height?: number; className?: string }) {
  return (
    <img
      src="/media/product-icons/logo-flow-wordmark.svg"
      alt="flow by innovaccer"
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  )
}
